import React from 'react';
import PropTypes from 'prop-types';

import {Box, List} from '@spothero/ui';

import NavigationItem from './NavigationItem';
import UserMenu from '../user-menu/UserMenu';

const navigationMenuContainerStyleProps = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
    width: 'full',
    height: 14,
};

const navigationMenuListStyleProps = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 4,
    height: 'full',
    paddingX: 4,
};

const NavigationMenu = ({menuRef, navigationRoutes}) => {
    return (
        <Box ref={menuRef} as="nav" {...navigationMenuContainerStyleProps}>
            <List
                data-testid="NavigationMenu"
                {...navigationMenuListStyleProps}
            >
                {navigationRoutes.map((navigationItem, index) => {
                    const {label, route, paths, children} = navigationItem;

                    return (
                        <NavigationItem
                            key={index}
                            label={label}
                            route={route}
                            paths={paths}
                            children={children}
                        />
                    );
                })}
            </List>
            <UserMenu />
        </Box>
    );
};

NavigationMenu.propTypes = {
    menuRef: PropTypes.object.isRequired,
    navigationRoutes: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            route: PropTypes.string,
            paths: PropTypes.arrayOf(PropTypes.string),
            children: PropTypes.arrayOf(
                PropTypes.shape({
                    heading: PropTypes.string.isRequired,
                    submenu: PropTypes.arrayOf(
                        PropTypes.shape({
                            label: PropTypes.string.isRequired,
                            route: PropTypes.string.isRequired,
                            paths: PropTypes.arrayOf(PropTypes.string),
                            subtitle: PropTypes.string,
                            isDisabled: PropTypes.bool,
                        })
                    ),
                })
            ),
        })
    ).isRequired,
};

export default NavigationMenu;
